export default {
    light: () => import('./theme-light.scss?inline'),
    dark: () => import('./theme-dark.scss?inline'),
};
